import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";

const DownloadAppCard = () => {
  return (
    <div className="bg-gray-100 flex justify-center mt-6 pt-6 rounded-lg mb-10">
        <div className=" flex flex-col lg:flex-row items-end xl:gap-6">
            <img className="" src="/images/app.png" alt="app" />
            <div className="lg:max-w-xl flex flex-col gap-10 py-12 px-6 lg:pl-0 lg:pr-6">
                <p className="text-4xl xl:text-5xl leading-[46px]">L'application mobile <span className="text-orange-hover font-medium">Kilimmanjaro</span> bientôt disponible !</p>

                <div className="flex w-full">
                    <input type="text" placeholder="Adresse mail" className="w-full px-5 py-2.5 border-2 border-gray-200 border-r-0 rounded-l-full"/>
                    <button className="text-white bg-red-500 px-6 rounded-r-full w-32">S'abonner</button>
                </div>
                <div className="flex items-center gap-6">
                    <img src="/images/google-play.png" alt="googleplay" />
                    <img src="/images/app-store.png" alt="appstore" />
                </div>
            </div>
        </div>
    </div>
  );
};

export default DownloadAppCard; 